export const useAnalytics = () => {
  const setAnalytics = (seo, langs) => {
    const headers = useRequestHeaders(["host"]);
    const host = process.client ? window.location.origin : headers.host;
    const id = /maxalto/.test(host) ? "GTM-PSGV76T" : "GTM-54HQLX3";

    const scripts = [
      {
        innerHTML: `dataLayer = [];`,
      },
      {
        innerHTML: `
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${id}');`,
      },
    ];

    const noscript = [
      {
        body: true,
        innerHTML: `<iframe src="https://www.googletagmanager.com/ns.html?id=${id}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
      },
    ];

    const obj = {
      script: scripts,
      noscript: noscript,
    };

    useHead(obj);
  };

  return {
    setAnalytics,
  };
};
